import { useState } from "react";

export default function SubscribeBand() {
  const [done, setDone] = useState(false);

  return (
    <section id="subscribe" className="w-full bg-primary-500 py-12 md:py-16">
      <div className="w-full px-4 md:px-8">
        <div className="flex flex-col gap-8 md:flex-row md:items-center md:justify-between">
          <div className="max-w-xl">
            <span className="font-label text-xs uppercase tracking-[0.35em] text-primary-100">
              Daily Digest
            </span>
            <h4 className="mt-3 font-heading text-2xl font-black leading-snug text-background-50 md:text-3xl">
              <a href="#subscribe" className="transition-colors hover:text-accent-200">
                把每日瓜报塞进你的收件箱
              </a>
            </h4>
            <p className="mt-3 text-sm leading-relaxed text-primary-100 md:text-base">
              每天推送当天的 TOP 榜前三、讨论最多的话题和话题墙新增标签，三分钟看完今日头条，不用再翻遍全网找料。
            </p>
          </div>

          <div className="w-full md:max-w-md">
            <div className="flex flex-col gap-3 sm:flex-row">
              <input
                type="email"
                placeholder="填个邮箱，只发瓜报"
                className="w-full rounded-full border border-primary-300/60 bg-background-50/10 px-4 py-3 text-sm text-background-50 placeholder:text-primary-100 focus:border-accent-400 focus:outline-none"
              />
              <button
                type="button"
                onClick={() => setDone(true)}
                className="flex shrink-0 cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-full bg-background-50 px-6 py-3 text-sm font-medium text-primary-700 transition-colors hover:bg-accent-100"
              >
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-send-plane-fill text-sm" />
                </span>
                订阅瓜报
              </button>
            </div>
            <p className="mt-3 text-xs text-primary-100">
              {done ? "已加入订阅清单（演示效果，暂未真实提交）" : "演示订阅，不会真实发送邮件，可放心点击。"}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}